import { CustomSpaceTypeStates, ICustomSpaceTypesState } from './types';
import {
  Actions,
  CREATE_CUSTOM_SPACE_TYPE,
  DELETE_CUSTOM_SPACE_TYPE,
  UPDATE_CUSTOM_SPACE_TYPE,
  SET_CURRENT_PARENT,
  SET_DIALOG_SPACE_TYPE_STATE,
} from './actions';

const initialState: ICustomSpaceTypesState = {
  busy: false,
  customSpaceTypes: [],
  currentState: CustomSpaceTypeStates.basicSpaceForm,
  currentParent: null,
};

const reducer = (
  state: ICustomSpaceTypesState = initialState,
  action: Actions
) => {
  switch (action.type) {
    case CREATE_CUSTOM_SPACE_TYPE:
    case UPDATE_CUSTOM_SPACE_TYPE:
    case DELETE_CUSTOM_SPACE_TYPE:
      return {
        ...state,
        busy: true,
      };
    case SET_DIALOG_SPACE_TYPE_STATE:
      return {
        ...state,
        currentState: action.payload.state,
      };
    case SET_CURRENT_PARENT:
      return {
        ...state,
        currentParent: action.payload.parent,
      };
    default:
      return state;
  }
};

export default reducer;
